import { createSvgIcon } from '../Utils/helpers';
export default createSvgIcon({
  name: 'ArrowDown',
  width: 1024,
  height: 1024,
  // eslint-disable-next-line max-len, comma-spacing
  paths: ['M0 322.389l512 530.944 512-530.944-146.219-151.723-365.781 379.349-365.653-379.349-146.347 151.723z']
});